// extracted by mini-css-extract-plugin
export default {"td":"PersonalizacaoAcessoIndex_td__Wpec-","trBody":"PersonalizacaoAcessoIndex_trBody__6KOm1","inscricao":"PersonalizacaoAcessoIndex_inscricao__JPqmq"};